import React from "react";
import { Spin } from "antd";
import { CardTable } from "../../../components/Card/CardTable";
import CardDetailProject from "../../../components/Card/CardDetailProject";
import useGraphArea from "./hooks/useGraphArea";
import Tabs from "./components/Tabs";
import { ContainerCardsAreasPie } from "../../../components/container";
import { PieChartGeneral } from "../../../components/Graphics/PieChartGeneral";
import { BarChartGeneral } from "../../../components/Graphics/BarChartGeneral";

export const PageGraphArea = () => {

    const {
        listOfYears,
        year,
        updateYear,
        currentStep,
        onChangeTab,
        isLoading,
        dataAreas,
        selectArea,
    } = useGraphArea()

    if (isLoading) return (
        <div className="flex justify-center items-center w-full min-h-[calc(100vh-64px)]">
            <Spin size="large" />
        </div>
    );

    return (
        <section style={{ height: "calc(100vh - 64px)" }} className="w-full p-4 ">
            <div className="w-full h-full bg-green-600">
                <CardTable title="" currentValue={year} listValues={listOfYears} updateValue={updateYear}>
                    <Tabs currentStep={currentStep} areas={dataAreas} onChange={(index) => onChangeTab(index)} />
                    <div className="w-full h-full grid grid-cols-1 xl:grid-cols-2 gap-6">
                        <CardDetailProject title="Secciones que componen el área">
                            <div className="w-full flex sm:flex-col md:flex-row xl:flex-col items-center gap-4">
                                <PieChartGeneral
                                    className="h-[280px] w-[280px]"
                                    pieChartProps={{
                                        enableArcLinkLabels: false,
                                        enableArcLabels: false,
                                        margin: { top: 16, right: 16, bottom: 16, left: 16 },
                                        data: selectArea.folderBreakdown,
                                        layers: ["arcs", "arcLabels", "arcLinkLabels", "legends", CenteredMetric],
                                        activeInnerRadiusOffset: 0,
                                        innerRadius: 0.6,
                                        valueFormat: (value) => {
                                            return `${value}`;
                                        },
                                    }}
                                />
                                <ContainerCardsAreasPie datas={selectArea.folderBreakdown} />
                            </div>
                        </CardDetailProject>
                        <CardDetailProject title="Desglose de Información">
                            <div className="w-full flex sm:flex-col md:flex-row xl:flex-col items-center gap-4">
                                <BarChartGeneral
                                    datas={selectArea.barBreakdown}
                                    keys={selectArea.keysBarBreakdown}
                                    className="h-[250px] w-full shrink-0"
                                    barChartProps={{
                                        margin: { top: 36, right: 36, bottom: 36, left: 60 },
                                        enableLabel: false,
                                        valueFormat: (value) => {
                                            return `${value}`;
                                        },
                                    }}
                                />
                                {selectArea.listBarContainer.map((item, index) => (
                                    <div key={`list-${index}`} className="w-full shrink-0">
                                        <CardDetailProject key={`list-${index}`} title={`Desglose de ${item.folderName}`}>
                                            <ContainerCardsAreasPie datas={item.listContainerBarBreakdown} />
                                        </CardDetailProject>
                                    </div>
                                ))}
                            </div>
                        </CardDetailProject>
                    </div>
                </CardTable>
            </div>
        </section>
    );
};

const CenteredMetric = ({ dataWithArc, centerX, centerY }) => {
    let total = 0;
    dataWithArc.forEach((datum) => {
        total += datum.value;
    });

    return (
        <text
            x={centerX}
            y={centerY}
            textAnchor="middle"
            dominantBaseline="central"
            style={{
                fontSize: "20px",
                fontWeight: 700,
            }}
        >
            {total.toFixed(2)} horas
        </text>
    );
};
